const twoFactorFormConstantsAR = {
  verficationTitle: 'التحقق',
  verficationEnterCode: 'أدخل رمز التحقق المكون من 6 أرقام المرسل إلى بريدك الإلكتروني المسجل',
  verficationExpiry: 'الرجاء مراعاة أن الرمز سيفقد صلاحيته خلال 30 دقيقة',
  verficationButtonText: 'التحقق',
  resendCode: 'إعادة إرسال',
  noCodeLabel: ' لم تتلقى الرمز؟',
  noEmailLabel: 'لم تصلك الرسالة؟',
  backToLogin: 'العودة إلى تسجيل الدخول',
};

export default twoFactorFormConstantsAR;
